module.exports = {
  API_LOGIN: "/admin/sys/login",

  API_USERROLELIST: "/admin/sys/getRoleList",

  API_COMMON_PROVINCE: "/common/selectProvinceList", //公共 - 获取省份

  API_IMPORTADDAPPROVED: "/administrator/importAddApproved",

  API_IMPORTADDJDESAPPROVED: "/administrator/importAddJdesApproved",

  API_IMPORTCHANGEJDESINSERT: "/administrator/importChangeJdesInsert",

  API_COMMON_CITY: "/common/selectCityList", //公共 - 获取城市

  API_COMMON_ADMINCITY: "/common/selectAdminCityList", //公共 - 获取区县

  API_COMMON_ADMINCITY_INFO: "/common/selectAdminCityByFkAdminCity", //公共 - 获取区县信息

  API_COMMON_CITYTYPE: "/common/selectCityTypeList", //公共 - 获取城市类别

  API_COMMON_BRAND: "/common/selectBrandList", //公共 - 品牌列表

  API_COMMON_DEALER_LEVEL: "/common/selectDealerLevelList", //公共 - 获取客户属性列表

  API_COMMON_BU: "/common/selectBuList", //公共 - 获取业务单位列表

  API_COMMON_DESTINATION: "/common/selectDestinationList", //公共 - 获取Destination列表

  API_COMMON_FEE_STATUS: "/common/selectFeeStatusList", //公共 - 获取申请费用状态列表

  API_COMMON_COOPERATION_STATUS: "/common/selectCooperationStatusList", //公共 - 获取合作状态列表

  API_COMMON_BUSSINESS_STATUS: "/common/selectBusinessStatusList", //公共 - 获取客户营业状态列表

  API_COMMON_STORE_TYPE: "/common/selectRetailTypeList", // 公共 - 门店类型

  API_COMMON_LOCATION_LIST: "/common/selectLocationList", // 公共 - location简单信息列表

  API_COMMON_ISLKA_LIST: "/common/selectisLkaList", // 公共 - 是否LKA选项列表

  API_COMMON_LOCATION_INFO: "/common/selectLocationInfo", // 公共 - location列表

  API_COMMON_STORE_INVEST_TYPE: "/common/selectLevelList", // 公共 - 门店投资属性

  API_RMBASE_OPERATION_LIST: "/rmbase/operation/list", //按钮列表

  API_RMBASE_OPERATION_ADD: "/rmbase/operation/add", //新增按钮

  API_RMBASE_OPERATION_UPDATE: "/rmbase/operation/update", //修改按钮

  API_RMBASE_OPERATION_DELETE: "/rmbase/operation/delete", //删除按钮

  API_RMBASE_SYSTEM_LIST: "/rmbase/system/list",

  API_RMBASE_SYSTEM_INIT: "/rmbase/system/init", //系统初始化

  API_DEPARTMENT_LEADER: "/department/leader", //部门初始化

  API_RMBASE_SYSTEM_ADD: "/rmbase/system/add", //系统初始化--系统管理新增

  API_RMBASE_SYSTEM_UPDATE: "/rmbase/system/update",

  API_RMBASE_SYSTEM_DELETE: "/rmbase/system/delete", //删除系统菜单

  API_RMBASE_SYSTEM_PROPERTY: "/rmbase/system/selectSystemProperty", //删除系统菜单

  API_RMBASE_SYSTEM_LOGINLOG: "/rmbase/system/sysLoginLog", //登录日志

  API_RMBASE_SYSTEM_LOGLIST: "/rmbase/system/systemLogList", //系统日志

  API_RMBASE_SYSTEM_OPERATELOGLIST: "/rmbase/system/operateLogList", //操作日志

  API_RMBASE_SYSTEM_SAVE_TOP_PROPERTY: "/rmbase/system/saveSystemPropertyTop", //保存顶级属性

  API_RMBASE_SYSTEM_SAVE_PROPERTY: "/rmbase/system/saveSystemProperty", //保存属性

  API_RMBASE_SYSTEM_UPDATE_TOP_PROPERTY:
    "/rmbase/system/updateSystemPropertyTop", //保存顶级属性

  API_RMBASE_SYSTEM_UPDATE_PROPERTY: "/rmbase/system/updateSystemProperty", //保存顶级属性

  API_RMBASE_SYSTEM_DELETE_PROPERTY: "/rmbase/system/deleteSystemProperty", //

  API_RMBASE_SYSTEM_SELECT_TABLE: "/rmbase/system/selectDBTableResource",

  API_RMBASE_SYSTEM_SELECT_DB: "/rmbase/system/selectDBResource",

  API_RMBASE_SYSTEM_EXEC_SQL: "/rmbase/system/execSql",

  API_RMBASE_SYSTEM_SETUP_LIST: "/rmbase/system/setupList", //首页快捷

  API_RMBASE_SYSTEM_SETUP_SAVE: "/rmbase/system/saveSetup", //保存首页快捷

  API_RMBASE_SYSTEM_SETUP_UPDATE: "/rmbase/system/updateSetup", //更新首页快捷

  API_RMBASE_SYSTEM_SETUP_DELETE: "/rmbase/system/deleteSetup", //删除首页快捷

  API_GETTPINFO_LIST: "/rmbase/TPPersonnelInfo/getTPInfo", //获取TP人员信息

  API_GETTPINFO_UPDATE: "/rmbase/TPPersonnelInfo/updateTPPersonList", //更新tp人员信息

  API_TPINFOEXPORT: "/rmbase/TPPersonnelInfo/tpInfoExport", //TP人员信息-导出

  API_TP_SELECTTABLE: "/rmbase/TPPersonnelInfo/selectTable",

  API_BUSETTING_LIST: "/buSetting/list", // 业务单位设定列表

  API_BUSETTING_ADD: "/buSetting/add", // 业务单位设定新增

  API_BUSETTING_UPDATE: "/buSetting/update", // 业务单位设定编辑

  API_BUSETTING_EXPORT: "/buSetting/exportBuSetting", //导出业务单位

  API_BUSETTING_DELETE: "/buSetting/delete", //删除业务单位

  API_BUSETTING_DISABLE: "/buSetting/disabled", //禁用业务单位

  API_BUSETTING_ENABLE: "/buSetting/enabled", //启用业务单位

  API_CITYTYPE_LIST: "/cityType/list", // 城市类别设定

  API_CITYTYPE_ADD: "/cityType/add", // 城市类别设定

  API_CITYTYPE_UPDATE: "/cityType/update", // 城市类别设定

  API_CITYTYPE_EXPORT: "/cityType/exportCityType", // 城市类别设定-导出

  API_CITYTYPE_DELETE: "/cityType/delete", //城市类别设定-删除

  API_CITYTYPE_DISABLE: "/cityType/disabled", //城市类别设定-禁用

  API_CITYTYPE_ENABLE: "/cityType/enabled", //城市类别设定-启用

  API_CUSTOMER_CHANNEL_LIST: "/customerChannel/list", //客户渠道设定-列表

  API_CUSTOMER_CHANNEL_ADD: "/customerChannel/add", //客户渠道设定-新增

  API_CUSTOMER_CHANNEL_UPDATE: "/customerChannel/update", //客户渠道设定-编辑

  API_CUSTOMER_CHANNEL_EXPORT: "/customerChannel/exportCustomerChannel", //客户渠道设定-导出

  API_CUSTOMER_CHANNEL_DELETE: "/customerChannel/delete", //客户渠道设定-删除

  API_CUSTOMER_CHANNEL_ENABLE: "/customerChannel/enabled", //客户渠道设定-启用

  API_CUSTOMER_CHANNEL_DISABLE: "/customerChannel/disabled", //客户渠道设定-禁用

  API_APPLYBRADN_LIST: "/applyBrand/list", // 适用品牌设定

  API_APPLYBRADN_ADD: "/applyBrand/add", // 适用品牌设定

  API_APPLYBRADN_UPDATE: "/applyBrand/update", // 适用品牌设定

  API_APPLYBRADN__EXPORT: "/applyBrand/exportApplyBrand", // 适用品牌设定-导出

  API_APPLYBRADN__DELETE: "/applyBrand/delete", // 适用品牌设定-删除

  API_APPLYBRADN__ENABLE: "/applyBrand/enabled", // 适用品牌设定-启用

  API_APPLYBRADN__DISABLE: "/applyBrand/disabled", // 适用品牌设定-禁用

  API_MDM_BACKLOG_LIST: "/mdm/BackLog/selectBackLog", // 待办事项列表

  API_EXPORTBACKLOG: "/mdm/BackLog/exportBackLog", // 待办事项列表-导出

  API_CUSTOMERTYPE: "/customerType/list", //客户类型列表

  API_CUSTOMERTYPE_ADD: "/customerType/add", //客户类型列表-新增

  API_CUSTOMERTYPE_UPDATE: "/customerType/update", //客户类型列表-编辑

  API_CUSTOMERTYPE_EXPORT: "/customerType/exportCustomerType", //客户类型列表-导出

  API_CUSTOMERTYPE_DELETE: "/customerType/delete", //客户类型列表-删除

  API_CUSTOMERTYPE_ENABLE: "/customerType/enabled", //客户类型列表-启用

  API_CUSTOMERTYPE_DISABLE: "/customerType/disabled", //客户类型列表-禁用

  API_ADDZONE: "/addZone", //销售大区管理-新增

  API_UPDATEZONE: "/updateZone", //销售大区管理-编辑

  API_EXPORTZONE: "/ZoneExport", //销售大区管理-导出

  API_SETZONESTATE: "/setZoneState", //销售大区管理-禁用

  API_UPDATEREGION: "/updateRegion", //销售区域管理-编辑

  API_ADDREGION: "/addRegion", //销售区域管理-新增

  API_EXPORTREGION: "/RegionExport", //销售区域管理-导出

  API_SETREGIONSTATE: "/setRegionState", //销售区域管理-禁用,启用，删除

  API_ADDPROVINCE: "/addProvince", //销售省份管理-新增

  API_UPDATEPROVINCE: "/updateProvince", //销售省份管理-编辑

  API_PROVINCEEXPORT: "/provinceExport", //销售省份管理-导出

  API_SETPROVINCESTATE: "/setProvinceState", //销售省份管理-禁用,启用，删除

  API_UPDATECITY: "/updateCity", //销售城市管理-编辑

  API_ADDCITY: "/addCity", //销售城市管理-新增

  API_CITYEXPORT: "/cityExport", //销售城市管理-导出

  API_SETCITYSTATE: "/setCityState", //销售城市管理-禁用,启用，删除

  API_QUERYZONE: "/queryZone", //销售大区管理-查看大区

  API_QUERYREGION: "/queryRegion", //销售区域管理-查看区域

  API_SALEFRAMEWORK_LIST_EXPORT: "/saleFrameworkListExport", //导出销售组织架构信息

  API_OLDSALEFRAMEWORK_LIST_EXPORT: "/oldSaleFrameworkListExport", //导出销售组织架构信息

  API_QUERYPROVINCE: "/queryProvince", //销售省份管理-查看省份

  API_QUERYPROVINCE_NOPAGE: "/queryProvinceNoPage", //销售省份管理-查看省份

  API_QUERYCITY: "/queryCity", //销售城市管理-查看城市

  API_SALES_ORGANIZTION_FRAMEWOrK: "/queryFramework",

  API_SALES_ORGANIZTION_FRAMEWORK_LIST: "/saleFrameworkList",

  API_SALES_ORGANIZTION_BULIST: "/buList",

  API_ADMIN_CITY_QUERY: "/queryAdminCity", //行政城市管理-查看

  API_ADMIN_CITY_ADD: "/addAdminCity", //行政城市管理-新增

  API_ADMIN_CITY_UPDATE: "/updateAdminCity", //行政城市管理-编辑

  API_ADMIN_CITY_EXPORT: "/adminCityExport", //行政城市管理-导出

  API_ADMIN_CITY_SET: "/setAdminCityState", //行政城市管理-禁用,启用，删除

  API_QUERT_AREAR_BY_GUID: "/queryAreaByBuGuid", //行政城市管理-禁用,启用，删除

  API_ADD_CORRELATION_AREA: "/addCorrelationArea", //

  API_UPDATE_CORRELATION_AREA: "/updateCorrelationArea", //

  API_QUERY_CORRELATION_AREA: "/queryCorrelationArea", //

  API_SELECTBACKLOGNAME: "/mdm/BackLog/selectBackLogName", //获取事件级别列表

  API_ADDBACKLOGNAME: "/mdm/BackLog/addBackLogName", //新增事件级别

  API_UPDBACKLOGNAME: "/mdm/BackLog/updBackLogName", //更新事件级别

  API_EXPORTBACKLOGNAME: "/mdm/BackLog/exportBackLogName", //事件级别-导出

  API_DISABLELOGNAME: "/mdm/BackLog/disablelogName", //事件级别-禁用

  API_ACCOUNTGROUPLIST: "/accountGroup/list", //获取预算Account组

  API_ACCOUNTGROUPADD: "/accountGroup/add", //预算Account组-新增

  API_ACCOUNTGROUPUPDATE: "/accountGroup/update", //预算Account组-编辑

  API_ACCOUNT_GROUP_EXPORT: "/accountGroup/exportSupplyMode", //预算Account组-导出

  API_ACCOUNT_GROUP_DELETE: "/accountGroup/delete", //预算Account组-删除

  API_ACCOUNT_GROUP_ENABLE: "/accountGroup/enabled", //预算Account组-启用

  API_ACCOUNT_GROUP_DISABLE: "/accountGroup/disabled", //预算Account组-禁用

  API_GETTABLEPERMISSIONSLIST:
    "/rmbase/TPPersonnelInfo/getTablePermissionsList", //表权限管理-列表和详情

  API_ADDTABLEPERMISSION: "/rmbase/TPPersonnelInfo/addTablePermission", //表权限管理-增加

  API_UPDATETABLEPERMISSIONS: "/rmbase/TPPersonnelInfo/updateTablePermissions", //表权限管理-编辑

  API_TABLEPERMISSIONEXPORT: "/rmbase/TPPersonnelInfo/tablePermissionExport", //表权限管理-导出

  API_TPPERSONNELINFO_BAN: "/rmbase/TPPersonnelInfo/ban", //表权限管理-禁用

  API_ADDCITYREGION: "/addCityRegion", //行政城市管理-新增

  API_SMMS_DEALER_OWNER_LIST: "/clientRelated/selectOwnSmmsDealerList", // 客户详情选择供货方

  API_SMMS_DEALER_LIST: "/clientRelated/selectSmmsDealerList", //客户列表，pageType 页面类型【0:新增-非SAP客户 1:变更-非SAP客户 2:非SAP客户待处理 3:非SAP客户新增审批 4:非SAP客户关联审批 5:非SAP客户变更审批 6:变更-SAP客户 7:任务-SAP客户待处理 8:任务-SAP客户合并】

  API_SMMS_DEALER_DEAL_BUTTON:
    "/clientRelated/selectSAPSmmsDealerOperaterButton", // 操作按钮[isAdd=1 显示确认新增客户 isMerge=1 显示确认合并客户]

  API_SMMS_DEALER_DEAL_COMBINE: "/clientRelated/confirmMergeSmmsDealer", // [任务-SAP客户合并]确认合并

  API_SMMS_DEALER_DEAL_CREATE: "/clientRelated/confirmNewAddSmmsDealer", // [任务-SAP客户待处理]确认新增客户

  API_SMMS_DEALER_LOG_LIST: "/clientRelated/selectSmmsDealerLogList", // 变更日志

  API_SMMS_NOSAP_LOGIN_LIST: "/clientRelated/selectWaitAuditSmmsDealerLogList", // 非sap变更审批日志

  API_SMMS_NOSAP_MATCH_RELATE: "/clientRelated/matchResultSmmsDealerRelated", // 匹配结果关联

  API_SMMS_ORIGINAL_REMOVE_RELATION:
    "/clientRelated/originalSmmsDealerRemoveRelated", // 原始客户信息移除关联

  API_SMMS_ClOSE_LIST: "/clientRelated/selectSmmsDealerCloseList", //获取任务-客户关闭审批列表【分页功能】

  API_SMMS_NOSAP_ClOSE_LIST: "/clientRelated/selectNoSapSMMSDealer", // 获取非SAP关闭客户列表

  API_SMMS_ORI_DEALER_LIST: "/clientRelated/selectOriginalSmmsDealerList", // 原始客户信息列表

  API_SMMS_SHIPTO_LIST: "/clientRelated/selectSmmsDealerShipToRelationList", //获取ShipTo信息列表

  API_SMMS_PLAYER_LIST: "/clientRelated/selectSmmsPayerRelationList", //获取Payer信息列表

  API_SMMS_SAVE_LIST: "/clientRelated/saveSmmsDealer", // 保存客户信息

  API_SMMS_UPDATE_LIST: "/clientRelated/updateSmmsDealer", // 编辑客户信息

  API_SMMS_DEALER_COMBINE_SAP_CREATE: "/clientRelated/sapSmmsDealerNewAdd", // 任务-SAP客户合并[SAP客户信息]新增

  API_SMMS_DEALER_SAP_RELATED_REMOVE:
    "/clientRelated/removeSAPSmmsDealerRelated", // 任务-SAP客户合并[SAP客户信息]移除关联

  API_SMMS_DEALER_SAP_SETTINGS_REMOVE:
    "/clientRelated/removeSAPSmmsDealerSettings", // 任务-SAP客户合并[SAP客户信息]移除设定/任务-SAP客户待处理移除设定

  API_SMMS_DEALER_SAP_COMBINE_REMOVE: "/clientRelated/removeSAPSmmsDealerMerge", // 任务-SAP客户待处理[SAP客户合并]移除合并

  API_SMMS_DEALER_MERGE: "/clientRelated/saveConfirmMergeSmmsDealer", // 确认合并客户

  API_SMMS_MATCHRESULT_LIST: "/clientRelated/selectMatchResultSmmsDealerList", //获取匹配结果列表

  API_SMMS_SAP_COMBINE_LIST: "/clientRelated/selectMergeSAPSmmsDealerList", //获取合并SAP客户信息列表

  API_STORE_PAYLINK_LIST: "/retailerManagement/selectPayLinkList", //获取PayLink列表

  API_SMMS_DEALER_CLOSE_LIST: "/clientRelated/selectSmmsDealerCloseList", // 获取任务-客户关闭审批列表

  API_STORE_VENDOR_LIST: "/retailerManagement/selectVendorList", // 获取付款用Vendor列表

  API_SMMS_DEALER_CLOSE_APPROVAL_PASS:
    "/clientRelated/smmsDealerCloseApprovalAuditPass", //任务-客户关闭审批审批通过

  API_SMMS_DEALER_CLOSE_APPROVAL_BACK:
    "/clientRelated/smmsDealerCloseApprovalAuditBack", //任务-客户关闭审批审批驳回

  API_SMMS_NOSAP_UPDATE_APPROVAL_PASS:
    "/clientRelated/smmsDealerNoSAPChangeApprovalAuditPass", //非SAP客户变更审批审核通过

  API_SMMS_NOSAP_UPDATE_APPROVAL_BACK:
    "/clientRelated/smmsDealerNoSAPChangeApprovalAuditBack", //非SAP客户变更审批审核驳回

  API_SMMS_NOSAP_CREATE_APPROVAL_PASS:
    "/clientRelated/smmsDealerNoSAPNewApprovalAuditPass", //非SAP客户新增审批审核通过

  API_SMMS_NOSAP_CREATE_APPROVAL_BACK:
    "/clientRelated/smmsDealerNoSAPNewApprovalAuditBack", //非SAP客户新增审批审核驳回

  API_SMMS_NOSAP_RELATED_APPROVAL_PASS:
    "/clientRelated/smmsDealerRelatedApprovalAuditPass", //非SAP客户关联审批审核通过

  API_SMMS_NOSAP_RELATED_APPROVAL_BACK:
    "/clientRelated/smmsDealerRelatedApprovalAuditBack", //非SAP客户关联审批审核驳回

  API_SMMS_NOSAP_APPROVAL_CREATE: "/clientRelated/smmsDealerNewAddAudit", // 非SAP客户待处理提交新增审核[fkAdminCity大于0时显示]

  API_ROLESMANAGEMENT_LIST: "/rolesManagement/list", //获取角色管理列表

  API_ROLESMANAGEMENT_ADD: "/rolesManagement/add", //角色管理-新增

  API_ROLESMANAGEMENT_UPDATE: "/rolesManagement/update", //角色管理-编辑

  API_ROLESMANAGEMENT_DELETE: "/rolesManagement/delete", //角色管理-删除

  API_ROLESMANAGEMENT_INIT: "/rolesManagement/init",

  API_ROLESMANAGEMENT_AUTHORITY: "/rolesManagement/distributeAuthority",

  API_ROLESMANAGEMENT_ADDUSERROLES: "/rolesManagement/addUserRoles",

  API_ROLESMANAGEMENT_GETROLELIST: "/rolesManagement/getRoleList",

  API_ROLESMANAGEMENT_SAVE: "/rolesManagement/save",

  API_DEPARTMENT_LIST: "/rmbase/department/list", //获取部门管理列表

  API_DEPARTMENT_ADD: "/rmbase/department/add", //部门管理-新增

  API_DEPARTMENT_DELETE: "/rmbase/department/delete", //部门管理-新增

  API_DEPARTMENT_UPDATE: "/rmbase/department/update", //部门管理-编辑

  API_DEPARTMENT_INIT: "/rmbase/department/init", //部门管理-编辑

  API_GETCOLUMNPERMISSIONINFO:
    "/rmbase/TPPersonnelInfo/getColumnPermissionInfo", //字段权限设定-列表和详情

  API_UPDATECOLUMNPERMISSIONINFO:
    "/rmbase/TPPersonnelInfo/updateColumnPermissionInfo", //字段权限设定-编辑

  API_COLUMNPERMISSIONEXPORT: "/rmbase/TPPersonnelInfo/columnPermissionExport", //字段权限设定导出

  API_BANCOLUNM: "/rmbase/TPPersonnelInfo/banColumn", //字段权限设定-禁用

  API_MANAGEMENTHIERARCHY_LIST: "/rmbase/managementHierarchy/list", //管理层级设定列表和详情

  API_INSERTMANAGEMENTHIERARCHY:
    "/rmbase/managementHierarchy/insertManagementHierarchy", //管理层级-增加

  API_UPDATEMANAGEMENTHIERARCHY:
    "/rmbase/managementHierarchy/updateManagementHierarchy", //管理层级-编辑

  API_MANAGEMENTHIERARCHY_EXPORT:
    "/rmbase/managementHierarchy/getManagementHierarchyListExport", //管理层级-导出

  API_SET_MANAGEMENT_HIERARCHY:
    "/rmbase/managementHierarchy/setManagementHierarchy", //管理层级-删除，启用，禁用

  API_SELECTMDMYEAR: "/dataVersionManagement/selectMdmYear", //查询-数据版本-年

  API_ADDMDMYEAR: "/dataVersionManagement/addMdmYear", //新增-数据版本-年

  API_UPDMDMYEAR: "/dataVersionManagement/updMdmYear", //更新-数据版本-年

  API_EXPORTMDMYEAR: "/dataVersionManagement/exportMdmYear", //导出-数据版本-年

  API_SELECTMDMCYCLE: "/dataVersionManagement/selectMdmCycle", //查询-数据版本-季

  API_ADDMDMCYCLE: "/dataVersionManagement/addMdmCycle", //新增-数据版本-季

  API_UPDMDMCYCLE: "/dataVersionManagement/updMdmCycle", //更新-数据版本-季

  API_EXPORTMDMCYCLE: "/dataVersionManagement/exportMdmCycle", //导出-数据版本-季

  API_SELECTMDMMONTH: "/dataVersionManagement/selectMdmMonth", //查询-数据版本-月

  API_ADDMDMMONTH: "/dataVersionManagement/addMdmMonth", //新增-数据版本-月

  API_UPDMDMMONTH: "/dataVersionManagement/updMdmMonth", //更新-数据版本-月

  API_EXPORTMDMMONTH: "/dataVersionManagement/exportMdmMonth", //导出-数据版本-月

  API_SUPPLYMODE_LIST: "/supplyMode/list", //供货方式设定列表

  API_SUPPLYMODE_ADD: "/supplyMode/add", //新增-供货方式设定

  API_SUPPLYMODE_UPDATE: "/supplyMode/update", //更新-供货方式设定

  API_SUPPLYMODE_EXPORT: "/supplyMode/exportSupplyMode", //导出-供货方式设定

  API_USER_INIT: "/rmbase/user/init", //用户管理初始化

  API_USER_LIST: "/rmbase/user/list", //用户列表

  API_USER_DELETE: "/rmbase/user/delete", //删除用户

  API_USER_DISABLE: "/rmbase/user/lock", //禁用用户

  API_USER_INFO: "/rmbase/user/info",

  API_USER_ADD: "/rmbase/user/add",

  API_USER_UPDATE: "/rmbase/user/update",

  API_USER_ENABLE: "/rmbase/user/authorization", //禁用用户

  API_USER_GROUP_LIST: "/rmbase/userGroup/list",

  API_USER_GROUP_NODE: "/rmbase/userGroup/node",

  API_USER_GROUP_ADD: "/rmbase/userGroup/save",

  API_USER_GROUP_UPDATE: "/rmbase/userGroup/update",

  API_USER_GROUP_DELETE: "/rmbase/userGroup/delete",

  API_USER_GROUP_SYS_MENU_INFO: "/rmbase/userGroup/querySysMenuInfo",

  API_USER_GROUP_SAVE_SYS_MENU: "/rmbase/userGroup/saveUserGroupRightList",

  API_USER_GROUP_GROUP: "/rmbase/userGroup/queryUserInfoListByUserGroupId",

  API_USER_GROUP_NOGROUP: "/rmbase/userGroup/queryNoGroupUserInfoList",

  API_USER_GROUP_SAVE_RELATION: "/rmbase/userGroup/saveUserInfoUserGroup",

  API_USER_GROUP_DELETE_RELATION: "/rmbase/userGroup/deleteUserInfoUserGroup",

  API_SUPPLYMODE_DISABLE: "/supplyMode/disabled", //禁用-供货方式设定

  API_SUPPLYMODE_ENABLED: "/supplyMode/enabled", //启用-供货方式设定

  API_SUPPLYMODE_DELETE: "/supplyMode/delete", //删除-供货方式设定

  API_SELECT_CUSTOMER_GROUP_INFO: "/parameterSetting/selectCustomerGroupInfo", //查看客户集团设定信息

  API_INSERT_CUSTOMER_GROUP: "/parameterSetting/insertCustomerGroup", //新增-客户集团设定

  API_UPDATE_CUSTOMER_GROUP: "/parameterSetting/updateCustomerGroup", //更新-客户集团设定

  API_CUSTOMER_GROUP_EXPORT: "/parameterSetting/customerGroupExport", //导出-客户集团设定

  API_SET_CUSTOMER_GROUP: "/parameterSetting/setCustomerGroup", //客户集团设定-禁用，启用，删除

  API_SELECT_RETAIL_TYPE_INFO: "/parameterSetting/selectRetailTypeInfo", //查看门店类型设定信息

  API_INSERT_RETAIL_TYPE: "/parameterSetting/insertRetailType", //新增-门店类型设定信息

  API_UPDATE_RETAIL_TYPE: "/parameterSetting/updateRetailType", //更新-门店类型设定信息

  API_RETRAIL_TYPE_EXPORT: "/parameterSetting/retailTypeExport", //导出-门店类型设定信息

  API_SET_RETAIL_TYPE: "/parameterSetting/setRetailType", //门店类型设定信息-禁用，启用，删除

  API_SELECT_LOCATION_INFO: "/parameterSetting/selectLocationInfo", //查看location设定信息

  API_SELECT_ATTR_LIST: "/service-attribute/list", //查看业务属性设定信息

  API_INSERT_ATTR: "/service-attribute/add", //新增业务属性设定信息

  API_INSERT_LOCATION: "/parameterSetting/insertLocation", //新增-location设定信息

  API_UPDATE_LOCATION: "/parameterSetting/updateLocation", //更新-location设定信息

  API_UPDATE_ATTR: "/service-attribute/update", //更新-业务属性设定信息

  API_LOCATION_EXPORT: "/parameterSetting/locationExport", //导出-location设定信息

  API_ATTR_EXPORT: "/service-attribute/exportAttr", //导出业务属性设定信息

  API_SET_LOCATION: "/parameterSetting/setLocation", //location设定信息-禁用，启用，删除

  API_SET_ATTR: "/service-attribute/setAttr", //业务属性信息-禁用，启用，删除

  API_SET_DEP: "/department/setDep", //部门信息-禁用，启用，删除

  API_DEP_EXPORT: "/department/exportDep", //导出部门信息

  API_UPDATE_DEP: "/department/update", //更新-部门信息

  API_INSERT_DEP: "/department/add", //新增部门信息

  API_SELECT_DEP_LIST: "/department/list", //查看部门信息

  API_SET_REG: "/region-org/setReg", //部门信息-禁用，启用，删除

  API_REG_EXPORT: "/region-org/exportRegion", //导出部门信息

  API_UPDATE_REG: "/region-org/update", //更新-部门信息

  API_INSERT_REG: "/region-org/add", //新增部门信息

  API_SELECT_REG_LIST: "/region-org/list", //查看部门信息

  API_SET_BRAND: "/brand/setBrand", //部门信息-禁用，启用，删除

  API_BRAND_EXPORT: "/brand/exportBrand", //导出部门信息

  API_UPDATE_BRAND: "/brand/update", //更新-部门信息

  API_INSERT_BRAND: "/brand/add", //新增部门信息

  API_SELECT_BRAND_LIST: "/brand/list", //查看部门信息

  API_SET_AREA: "/area-org/setArea", //地区信息-禁用，启用，删除

  API_AREA_EXPORT: "/area-org/exportArea", //导出地区信息

  API_UPDATE_AREA: "/area-org/update", //更新-地区信息

  API_INSERT_AREA: "/area-org/add", //新增地区信息

  API_SELECT_AREA_LIST: "/area-org/list", //查看地区信息

  API_SET_CHANNEL: "/channel/setChannel", //渠道信息-禁用，启用，删除

  API_CHANNEL_EXPORT: "/channel/exportChannel", //导出渠道信息

  API_UPDATE_CHANNEL: "/channel/update", //更新-渠道信息

  API_INSERT_CHANNEL: "/channel/add", //新增渠道信息

  API_SELECT_CHANNEL_LIST: "/channel/list", //查看渠道信息

  API_SELECT_RETAIL_LEVEL_INFO: "/parameterSetting/selectRetailLevelInfo", //查看门店投资属性信息

  API_INSERT_RETAIL_LEVEL: "/parameterSetting/insertRetailLevel", //新增-门店投资属性信息

  API_UPDATE_RETAIL_LEVEL: "/parameterSetting/updateRetailLevel", //更新-门店投资属性信息

  API_RETRAIL_LVEVL_EXPORT: "/parameterSetting/retailLevelExport", //导出-门店投资属性信息

  API_SET_RETAIL_LEVEL: "/parameterSetting/setRetailLevel", //门店投资属性信息-禁用，启用，删除

  API_STORE_MATCH_LIST: "/retailerManagement/selectMatchResultList", // 门店 - 匹配列表

  API_STORE_RETAILER_LIST: "/retailerManagement/selectRetailerDealerList", // 门店 - 供货方列表

  API_STORE_ORIGINAL_LIST: "/retailerManagement/selectOriginalRetailerList", // 原始门店列表

  API_STORE_SALE_ARCHITECTURE_LIST:
    "/retailerManagement/selectSalesRetailerDealerList", // 销售架构列表

  API_STORE_SHIPTO_LIST: "/retailerManagement/selectShipToRelationList", // 门店 - ShipTo信息列表

  API_STORE_PAYER_LIST: "/retailerManagement/selectPayerRelationList", // 门店 - Payer信息列表

  API_STORE_UPDATE_LOG_LIST: "/retailerManagement/selectRetailerLogList", // 门店变更信息列表

  API_STORE_UPDATE_TASK_LOG_LIST:
    "/retailerManagement/selectWaitAuditRetailerLogList", //获取[门店变更审批]变更信息列表

  API_STORE_MATCHRESILT_RELATED: "/retailerManagement/matchResultRelated", // 匹配结果关联

  API_STORE_ORIGINAL_RELATED_REMOVE: "/retailerManagement/removeRelated", // 原始门店移除关联

  API_STORE_ORIGINAL_SETTING_REMOVE: "/retailerManagement/removeSetting", // 原始门店移设定

  API_STORE_SFA_RECOVER_SWITCH: "/retailerManagement/updateRetailerDealerSFA", // SFA覆盖开关

  API_STORE_CHANGE_APPROVAL_BACK:
    "/retailerManagement/retailerChangeApprovalAuditBack", //任务-门店变更审批审核驳回

  API_STORE_CHANGE_APPROVAL_PASS:
    "/retailerManagement/retailerChangeApprovalAuditPass", //任务-门店变更审批审核通过

  API_STORE_CREATE_APPROVAL_BACK:
    "/retailerManagement/retailerNewApprovalAuditBack", //任务-门店新增审批审核驳回

  API_STORE_CREATE_APPROVAL_PASS:
    "/retailerManagement/retailerNewApprovalAuditPass", //任务-门店新增审批审核通过

  API_STORE_RELATED_APPROVAL_BACK:
    "/retailerManagement/retailerRelatedApprovalAuditBack", //任务-门店关联审批审核驳回

  API_STORE_RELATED_APPROVAL_PASS:
    "/retailerManagement/retailerRelatedApprovalAuditPass", //任务-门店关联审批审核通过

  API_STORE_SFA_APPROVAL_PASS:
    "/retailerManagement/retailerSFAApprovalAuditPass", //任务-SFA覆盖审批审核通过

  API_STORE_DELETE: "/retailerManagement/deleteRetailer", // 删除门店

  API_STORE_RETAILER_DELETE: "/retailerManagement/deleteRetailerDealer", // 删除供货方

  API_STORE_INFO_SAVE: "/retailerManagement/saveRetailer", // 保存门店

  API_STORE_INFO_UPDATE: "/retailerManagement/updateRetailer", // 更新门店

  API_STORE_RETAILER_SAVE: "/retailerManagement/saveRetailerDealerDto", //保存供货方

  API_STORE_RETAILER_UPDATE: "/retailerManagement/updateRetailerDealer", // 更新供货方

  API_STORE_INFO: "/retailerManagement/selectRetailerDetailInfo", // 门店详情

  API_SEGMENT_LIST: "/segment/list", //segment设定-列表

  API_SEGMENT_ADD: "/segment/add", //segment设定-新增

  API_SEGMENT_UPDATE: "/segment/update", //segment设定-更新

  API_SEGMENT_EXPORT: "/segment/exportSegment", //segment设定-导出

  API_SEGMENT_DELETE: "/segment/delete", //segment设定-删除

  API_SEGMENT_ENABLE: "/segment/enabled", //segment设定-启用

  API_SEGMENT_DISABLE: "/segment/disabled", //segment设定-禁用

  API_DESTINATION_LIST: "/destination/list", //destination设定-列表

  API_DESTINATION_ADD: "/destination/add", //destination设定-新增

  API_DESTINATION_UPDATE: "/destination/update", //destination设定-更新

  API_DESTINATION_EXPORT: "/destination/exportDestination", //destination设定-导出

  API_DESTINATION_DELETE: "/destination/delete", //destination设定-删除

  API_DESTINATION_ENABLE: "/destination/enabled", //destination设定-启用

  API_DESTINATION_DISABLE: "/destination/disabled", //destination设定-禁用

  API_GET_MDM_LIST: "/getMDMList", //查询MDM门店-列表

  API_GET_OLDRETAIL_LIST: "/getOldRetail", //查询原始门店-列表

  API_GET_DOWNRETAIL_LIST: "/getDownRetail", //查询关闭门店-列表

  API_GET_POSINFO: "/getPosInfo", //查询POS信息

  API_POSINFO_UPDATE: "/retailerManagement/updatePosInfo",

  API_STORE_UNHANDLE_APPROVAL_SUBMIT: "/retailerManagement/submitAddAudit", // 待处理门店-提交新增审核

  API_SELECT_RETAILER_LIST: "/retailerManagement/selectRetailerList", //获取门店列表【分页功能】

  API_STORE_VENDOR: "retailerManagement/selectVendor", //获取Vendor

  API_STORE_PAYLINK: "retailerManagement/selectPayLink", //获取PayLink

  // API_SELECT_POSRETAILER_LIST:'/mdm/MyWorkbench/selectPosRetailerListDto',//获取NKA POS门店报告清单
  API_SELECT_POSRETAILER_LIST: "/mdm/MyWorkbench/selectNKAPosRetailerListDto", //获取NKA POS门店报告清单

  API_SELECT_LKAPOSRETAILER_LIST:
    "/mdm/MyWorkbench/selectLKAPosRetailerListDto", //获取LKA POS门店报告清单

  // API_POSRETAILERLIST_EXPORT:'/mdm/MyWorkbench/exportPOSRetailerList',//导出POS门店清单

  API_POSRETAILERLIST_EXPORT: "/mdm/MyWorkbench/exportNKAPOSRetailerList", //导出NKAPOS门店清单

  API_LKAPOSRETAILERLIST_EXPORT: "/mdm/MyWorkbench/exportLKAPOSRetailerList", //导出LKAPOS门店清单

  API_SELECT_RETAILER_LISTDTO: "/mdm/MyWorkbench/selectRetailerListDto", //获取MDM门店报告清单

  API_MDMRETAILER_EXPORT: "/mdm/MyWorkbench/exportMDMRetailerList", //导出MDM门店清单

  API_WORKBENCH_LODING_INFO: "/mdm/MyWorkbench/lodingInfo",

  API_WORKBENCH_SERVICE: "mdm/MyWorkbench/selectCustomerServiceDto",

  API_ORIGINAL_CUSTOMER_LIST: "/CustomerInfoController/originalCustomerList", //原始客户列表

  API_MDM_CUSTOMER_LIST: "/CustomerInfoController/MDMCustomerList", //MDM客户列表

  API_CUSTOMERCLASSIFY_LIST: "/customerClassify/list", //客户集团分类-列表

  API_Leader_LIST: "/org-rep/leader", //负责人-列表

  API_LEADER_DEPARTMENT_LIST: "/org-rep/departmentLeaderList", //部门负责人

  API_CUSTOMERCLASSIFY_ADD: "/customerClassify/add", //客户集团分类-新增

  API_CUSTOMERCLASSIFY_UPDATE: "/customerClassify/update", //客户集团分类-更新

  API_CUSTOMERCLASSIFY_EXPORT: "/customerClassify/exportCustomerClassify", //客户集团分类-导出

  API_CUSTOMERCLASSIFY_DELETE: "/customerClassify/delete", //客户集团分类-删除

  API_CUSTOMERCLASSIFY_ENABLE: "/customerClassify/enabled", //客户集团分类-启用

  API_CUSTOMERCLASSIFY_DISABLE: "/customerClassify/disabled", //客户集团分类-禁用

  API_DATADICTIONARY_LIST: "/dataDictionary/list", //数据字典-列表

  API_DATADICTIONARY_ADD: "/dataDictionary/add", //数据字典-新增

  API_DATADICTIONARY_UPDATE: "/dataDictionary/update", //数据字典-更新

  API_DATADICTIONARY_EXPORT: "/dataDictionary/exportDataDictionary", //数据字典-导出

  API_DATADICTIONARY_DELETE: "/dataDictionary/delete", //数据字典-删除

  API_DATADICTIONARY_ENABLE: "/dataDictionary/enabled", //数据字典-启用

  API_DATADICTIONARY_DISABLE: "/dataDictionary/disabled", //数据字典-禁用

  API_SELECT_RETAILERHISTORY_LIST:
    "/dataVersionManagement/selectRetailerHistory", //查询门店历史数据

  API_RETAILERHISTORY_EXPORT: "/dataVersionManagement/exportRetailerHistory", //门店历史数据-导出

  API_SELECT_CUSTOMERHISTORY_LIST:
    "/dataVersionManagement/selectCustomerHistory", //查看客户历史数据

  API_CUSTOMERHISTORY_EXPORT: "/dataVersionManagement/exportCustomerHistory", //客户历史数据-导出

  API_MDMCUSTOMER_EXPORT: "/CustomerInfoController/exportMdmCustomer", //MDM客户导出

  API_ORIGINALCUSTOMER_EXPORT: "/CustomerInfoController/exportOriginalCustomer", //原始客户导出

  API_NOSAPSMMSDEALER_EXPORT: "/clientRelated/exportNoSapSMMSDealer", //导出非SAP关闭客户列表

  API_SMMSDEALER_EXPORT: "/clientRelated/exportSmmsDealer", //客户导出(0:新增-非SAP客户 1:变更-非SAP客户 2:非SAP客户待处理
  // 3:非SAP客户新增审批 4:非SAP客户关联审批 5:非SAP客户变更审批 6:变更-SAP客户 7:任务-SAP客户待处理 8:任务-SAP客户合并)

  API_SMMSDEALERCLOSE_EXPORT: "/clientRelated/exportSmmsDealerClose", //任务-客户关闭审批导出

  API_SELECT_RETAILERREPORT_LIST: "/mdm/MyWorkbench/selectRetailerReport", //获取门店增减变化统计报告列表

  API_MDMCUSTOMER_IMPORT: "/CustomerInfoController/batchImportMdmCustomer", //MDM客户查询-批量更新

  API_SMMSDEALER_IMPORT: "/clientRelated/batchImportSmmsDealer", //新增非SPA客户-导入

  API_QUERYMDM_BATCHUPDATE: "/batchUpdate", //查询MDM门店-批量更新

  API_RETAILER_BATCHIMPORT: "/retailerManagement/batchImportRetailer", //门店批量导入

  API_POSRETAILER_IMPORT: "/retailerManagement/importPOSRetailer", //POS门店导入

  API_SALEFRAMEWORK_LIST_IMPORT: "/importSaleFrameworkList", //销售架构设定-导入

  API_OLDSALEFRAMEWORK_LIST_IMPORT: "/importOldSaleFrameworkList", //历史销售架构设定-导入

  API_RETAILER_EXPORT: "/retailerManagement/exportRetailer", //门店导出【pageType 0:新增-门店模块 1:任务-待处理门店模块
  // 2:任务-门店新增审批 3:任务-门店关联审批 4:任务-SFA覆盖审批 5:变更-门店模块 6:任务-门店变更审批模块】

  API_MDMRETAIL_INFO_EXPORT: "/MDMRetailInfoExport", //门店前三个导出【flag MDM门店查询 = 1，原始门店 = 2 ，已关闭门店 = 3】

  API_ADD_CUSTOMER_SERVICE: "/mdm/MyWorkbench/addCustomerServiceDto",

  API_SSO_ACCESSTOKEN: "/common/getSSOAccesstoken", //获取sso服务器的accesstoken

  API_SSO_LOGIN: "/common/login",

  API_SSO_LOGIN_FCST: "common/login",

  API_SYSTEM_USER_INFO: "/common/getUserInfo",

  // ------------------------分割线------------------------
  BASICS_FINDHOSPITALLIST: "/otc/basics/findHospitalList",

  BASICS_FINDPROVINNCECITYLIST: "/otc/basics/findProvinceCityList",

  BASICS_FINDPHASINGLIST: "/otc/basics/findPhasingList",

  BASICS_FINDPRODUCTLINELIST: "/otc/basics/findProductLineList",

  BASICS_FINDRELATEDSCALECONFIGLIST: "/otc/basics/findRelatedScaleConfigList",

  BASICS_FINDINDEXCONVERCONFIGLIST: "/otc/basics/findIndexConverConfigList",

  BASICS_DELETEINDEXCONVER: "/otc/basics/deleteIndexConver",

  BASICS_FINDESTIMATEDSALESLIST: "/otc/basics/findEstimatedSalesList",

  BASICS_ADJUSTSALESLIST: "/otc/adjustSales/findAdjustSalesList",

  BASICS_IMPORTADJUSTSALAS: "/otc/adjustSales/importAdjustSales",

  BASICS_EXPORRTADJUSTSALAS: "/otc/adjustSales/exportAdjustSales",

  BASICS_DEIETEADJUSTSALES: "/otc/adjustSales/deleteAdjustSales",

  BASICS_FINDSALESCAPTURELIST: "/otc/basics/findSalesCaptureList",

  BASICS_FINDRETURNINDEXLIST: "/otc/basics/findReturnIndexList",

  BASICS_GETYEAR: "/otc/basics/getYear",

  BASICS_FONDHOSPPOSITIONLIST: "/otc/basics/findHospPositionList",

  USER_LIST: "/rmbase/user/list",

  BASICS_FONDPRODUCTLINEPULLDOWNLIST: "/otc/basics/findProductLinePullDownList",

  USERGROUP_LIST: "/rmbase/userGroup/list",

  INDEXSETTING_FINDINDEXLIST: "/otc/indexSetting/findIndexList",

  INDEXSETTING_FINDSTARTLEVEL: "/otc/indexSetting/findStartLevel",

  INDEXSETTING_FINDINDEXSBYSL: "/otc/indexSetting/findIndexSBySL",

  INDEXSETTING_GETLESHOWSTATUS: "/otc/adjustSales/getLEShowStatus",

  INDEXSETTING_GETFREQUENCYYEARBYBU: "/otc/indexSetting/getFrequencyYearByBu",

  INDEXSETTING_SAVEINDEXSETTING: "/otc/indexSetting/saveIndexSetting",

  INDEXAPPROVE_TODOLIST: "/otc/indexApprove/toDoList",

  INDEXAPPROVE_TODODOWNLOADDETAIL: "/otc/indexApprove/toDoDownloadDetail",

  INDEXSETTING_MYINDEX: "/otc/indexSetting/myIndex",

  INDEXSETTING_IMPORTINDEXSETTING: "/otc/indexSetting/importIndexSetting",

  INDEXSETTING_SUBMITINDEX: "/otc/indexSetting/submitIndex",

  INDEXSETTING_UPDATEINDEX: "/otc/indexSetting/updateIndex",

  INDEXSETTING_APPROVE: "/otc/indexApprove/approve",

  INDEXSETTING_FINDSUBORDINDATELIST: "/otc/indexApprove/findSubordinateList",

  INDEXSETTING_INDEXAPPROVELIST: "/otc/indexApprove/indexApproveList",

  INDEXSETTING_SALESAPPROVE: "/otc/indexApprove/salesApprove",

  INDEXSETTING_FINDSUBSUBSCHEDULELIST:
    "/otc/indexApprove/findSubSubScheduleList",

  INDEXSETTING_RECALLINDEX: "/otc/indexSetting/recallIndex",

  INDEXSETTING_FINDPRODUCTLINEPULLDOWNLIST:
    "/otc/basics/findProductLinePullDownList",

  INDEXSETTING_FINDINDEXALLOCATION: "/otc/indexSetting/findIndexAllocation",

  INDEXSETTING_DELINDEX: "/otc/indexSetting/delIndex",

  INDEXSETTING_FINDSUBORDINATELIST: "/otc/indexApprove/findSubordinateList",

  INDEXSETTING_FINDSUBORDINATELIST1: "/otc/indexApprove/findIndexAllocation",

  INDEXSETTING_MTINDEXEXPORT: "/otc/indexSetting/myIndexExport",

  INDEXSETTING_TODODOWNLOADDETAIL: "/otc/indexSetting/toDoDownloadDetail",

  SYSTEM_LOG_EXPORT: "rmbase/user/logExport",

  INDEXSETTING_ADDHOSPITALINDEX: "/otc/indexSetting/addHospitalIndex",
  INDEXSETTING_ADDHOSPITALINDEXBW: "/otc/indexSetting/addHospitalIndexBW",

  INDEXSETTING_GETREJECTMEMO: "/otc/indexSetting/getRejectMemo",

  INDEXSETTING_INDEXSETTINGTEMEXCEL: "/otc/indexSetting/indexSettingTempExcel",

  INDEXSETTING_UPDATEHOSPREP: "/otc/indexSetting/updateHospRep",

  INDEXSETTING_INDEXCOLLECT: "otc/indexCollect/indexCollect",

  INDEXSETTING_INDEXSCHEDULE: "/otc/indexCollect/indexSchedule",

  INDEXSETTING_INDEXCOLLECTLE: "/otc/indexCollect/indexCollectLE",

  INDEXSETTING_INDEXSUPERIORAUDIT: "/otc/indexCollect/indexSuperiorAudit",

  INDEXSETTING_ORGMAPPINGLIST: "/rmbase/user/orgMappingList",

  INDEXSETTING_ORGMAPPING: "/rmbase/user/orgMapping",

  INDEXSETTING_ORGLIST: "/rmbase/user/orgList",

  INDEXSETTING_DELETEPOST: "/rmbase/user/deletePost",

  INDEXSETTING_BUSETTINGLIST: "/otc/buSetting/list",

  INDEXSETTING_ENABLIED: "/otc/buSetting/enabled",

  INDEXSETTING_BWENABLIED: "/otc/buSetting/bwEnabled",

  INDEXSETTING_HIDELASTTWOSALESENABLED: "/otc/buSetting/hideLastTwoSalesEnabled",

  INDEXSETTING_FINDCHECKITEMLIST: "/otc/basics/findCheckItemList",

  INDEXSETTING_EXPORTCHECKITEM: "/otc/basics/exportCheckItem",

  INDEXSETTING_IMPORTCHECKITEM: "/otc/basics/importCheckItem",

  INDEXSETTING_BASICSISCHECK: "/otc/basics/isCheck",

  INDEXSETTING_IMPORTINDEXCONVER: "/otc/basics/importIndexConver",

  INDEXSETTING_POSITIONLOGIN: "/admin/sys/positionLogin",

  INDEXSETTING_TSMCHECKITEMDETAILEXPORT:
    "/otc/indexSetting/tsmCheckItemDetailExport",

  INDEXSETTING_BUISPRDUCTLINE: "/otc/buSetting/buIsProductLine",

  INDEXSETTING_GETHOSPITALADDPRODUCTLINE:
    "/otc/indexSetting/getHospitalAddProductLine",

  IND_TODOWNLOADDETAIL: "/otc/indexSetting/toDoDownloadDetail",

  IND_FINDPRODFCSTLIST: "/fast/findProdFcstList",

  IND_SELECTCOLS: "/fast/selectCols",

  IND_CREATEFCST: "/fast/CreateFcst",

  IND_UPDATEFCSTSTATUS: "/fast/publishData",

  IND_COMMITDATA: "/fast/commitData",

  IND_FINDIDS: "/fast/findIds",

  IND_FINDSEACCHLIST: "/fast/findSearchList",

  IND_EXPORTFCSTBYPROD: "/fast/exportFcstByProd",

  IND_FINDPRODUCTLINELIST: "/fast/findProductLineList",

  IND_SELECTEDITION: "/fast/selectEdition",

  IND_UPDATEFCSTVALUE: "/fast/UpdateFcstValue",

  IND_CANCELLATION: "/otc/indexSetting/cancellation",

  IND_FINDALLBULIST: "/fast/findAllBuList",

  IND_FINDALLBULEVEL: "/fast/findBuLevel",

  IND_INSERTBULEVEL: "/fast/insertBuLevel",

  IND_DELETEBULEVEL: "/fast/deleteBuLevel",

  IND_EXPORTFCSTBYPROD1: "/fast/exportFcstByProd",

  IND_IMPORTFCSTDATA: "/fast/importFcstData",

  IND_UPDATESTOPINDEX: "/otc/indexSetting/updateStopIndex",

  IND_PRODUCTLINENAMEPROPORTION: "/otc/indexSetting/productLineNameProportion",

  IND_UPDATEAPPROVESTATUS: "/otc/indexApprove/updateApproveStatus",

  IND_BATCHAPPROVE: "/otc/indexApprove/batchApprove",

  IND_GETAUTOAPPROVECONFIGLIST: "/otc/indexApprove/getAutoApproveConfigList",

  IND_UNDATEAUTOAPPROVECONFIG: "/otc/indexApprove/updateAutoApproveConfig",

  IND_UPDATEHOSPREP: "/otc/indexSetting/updateHospRep",

  IND_UPDATEHOSPITALLINEPRE: "/otc/indexSetting/updateHospitalLinePre",

  IND_REMOVEDATA: "/fast/removeData",

  IND_INDEXCOLLECTLOGO: "/otc/indexCollect/indexLogo",

  IND_INDEXCOLLECT: "/otc/indexCollect/indexCollect",

  IND_GETADDPOSITIONINFO: "/otc/indexSetting/getAddSalesPositionInfo",

  IND_ADDSALESPOSITION: "/otc/indexSetting/addSalesPosition",

  IND_DELSALESPOSITION: "/otc/indexSetting/delSalesPosition",

  IND_UPDATESALESPOSITION: "/otc/indexSetting/updateSalesPosition",

  IND_GETUSERINFOBYPKID: "rmbase/user/getUserInfoByPkid",

  IND_LEVELGROUPDOWNLOAD: "otc/buSetting/levelGroupDownLoad",

  IND_GETLEVELGROUPLIST: "otc/buSetting/getLevelGroupList",

  IND_LEVELGROUPIMPORT: "otc/buSetting/levelGroupImport",

  IND_HOSPPOSITIONIMPORT: "otc/buSetting/hospPositionImport",

  IND_GETupdatestatus: "otc/indexSetting/getUpdateStatus",

  IND_UPDATEINDEXDEATILBACKUP: "otc/indexSetting/updateIndexDetailBackUp",

  IND_IMPORTBASEUSERINFO: "/rmbase/user/importBaseUserInfo",

  IND_IMPORTHOSPITALTYPING: "otc/basics/importHospitalTyping",

  IND_SELECTMONTH: "/fast/selectMonth",

  IND_FINDCOLLECT: "/fast/findCollect",

  IND_FINDCOLLECTLIST: "/fast/findCollectList",

  IND_UPDATEINDEXCOUNT: "/otc/basics/updateIndexCount",

  IND_UPDATEUSEDECIMAL: "/otc/basics/updateUseDecimal",

  IND_FINDPOSITIONNAMELIST: "/otc/basics/findPositionNameList",

  IND_FINDPOSITIONTYPELIST: "/otc/basics/findPositionTypeList",

  IND_SELECTINTERSECTMONTH: "/fast/SelectIntersectMonth",

  IND_CITEFCST: "/fast/CiteFcst",

  IND_FINDPROVINCECITY: "/otc/basics/findProvinceCity",

  IND_EXPORTPRODUCTLINESCSIMS: "/otc/basics/exportProductLineSCSIMS",

  IND_DELETEPRODUCTLINESCSIMS: "/otc/basics/deleteProductLineSCSIMS",

  IND_EXPORTPHASING: "/otc/basics/exportPhasing",

  IND_IMPORTPHASING: "/otc/basics/importPhasing",

  IND_IMPORTESTIMATEDSALES: "/otc/basics/importEstimatedSales",

  IND_EXPORTESTIMATEDSALES: "/otc/basics/exportEstimatedSales",

  IND_DELETEESTIMATEDSALES: "/otc/basics/deleteEstimatedSales",

  IND_IMPORTRELATEDSCALECONFIG: "/otc/basics/importRelatedScaleConfig",

  IND_IMPORTPRODUCTLINESCSIMS: "/otc/basics/importProductLineSCSIMS",

  IND_FONDSTARTLEVELALL: "/otc/indexApprove/findStartLevelAll",

  IND_INTERFACEJOB_READBP: "/interfaceJob/readBp",

  IND_FINDCOLLECTLISTTWO: "/fast/findCollectListTwo",

  IND_EXPORTFCST: "/fast/exportFcst",

  IND_PROVINCEINDEX: "/otc/indexSetting/getLeaderDistributionProvinceIndex",

  getRepList: "otc/indexSetting/getRepList",

  syncBaseUserInfo: "/rmbase/user/syncBaseUserInfo",

  syncBaseUser_DOWNTOPENABLED: "/otc/buSetting/downTopEnabled",
};



// WEBPACK FOOTER //
// ./src/api/api.js